import React from 'react';
import { Container, Typography, Paper, Box, Divider } from '@mui/material';

export default function Terms() {
    return (
        <Container maxWidth="md" sx={{ py: 4 }}>
            <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
                <Typography variant="h4" fontWeight={800} gutterBottom>
                    Allgemeine Geschäftsbedingungen (AGB)
                </Typography>
                <Typography variant="body2" color="text.secondary" paragraph>
                    Stand: 06. Januar 2026
                </Typography>
                
                <Divider sx={{ my: 3 }} />

                <Box sx={{ mb: 4 }}>
                    <Typography variant="h6" fontWeight={700} gutterBottom>
                        1. Geltungsbereich
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Diese Allgemeinen Geschäftsbedingungen gelten für die Nutzung der Anwendung "Schreiberlein" und alle damit verbundenen Dienstleistungen von Albert Tools.
                    </Typography>
                </Box>

                <Box sx={{ mb: 4 }}>
                    <Typography variant="h6" fontWeight={700} gutterBottom>
                        2. Leistungen
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Schreiberlein bietet Funktionen zur Erstellung von Rechnungen, Angeboten und zur Verwaltung von Buchhaltungsdaten. Der genaue Funktionsumfang richtet sich nach dem jeweils gewählten Abonnement-Tarif.
                    </Typography>
                </Box>

                <Box sx={{ mb: 4 }}>
                    <Typography variant="h6" fontWeight={700} gutterBottom>
                        3. Registrierung und Vertragsschluss
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Durch Abschluss des Registrierungsvorgangs und Auswahl eines Tarifs gibt der Nutzer ein Angebot zum Abschluss eines Nutzungsvertrages ab. Der Vertrag kommt mit der Bereitstellung des Zugangs durch den Betreiber zustande.
                    </Typography>
                </Box>

                <Box sx={{ mb: 4 }}>
                    <Typography variant="h6" fontWeight={700} gutterBottom>
                        4. Zahlungsbedingungen
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Die Vergütung für die Nutzung richtet sich nach der aktuellen Preisliste. Zahlungen werden über den Partner Mollie abgewickelt. Der Zugang wird unmittelbar nach erfolgreicher Zahlung freigeschaltet.
                    </Typography>
                </Box>

                <Box sx={{ mb: 4 }}>
                    <Typography variant="h6" fontWeight={700} gutterBottom>
                        5. Laufzeit und Kündigung
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Abhängig vom gewählten Tarif (monatlich oder jährlich) verlängert sich der Vertrag automatisch, sofern er nicht vor Ablauf der aktuellen Periode gekündigt wird. Die Kündigung kann jederzeit über den Account-Bereich erfolgen.
                    </Typography>
                </Box>

                <Box>
                    <Typography variant="h6" fontWeight={700} gutterBottom>
                        6. Haftungsbeschränkung
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Der Betreiber haftet nur für Schäden, die auf einer vorsätzlichen oder grob fahrlässigen Pflichtverletzung beruhen. Für die Richtigkeit der steuerlichen Auswertungen ist der Nutzer selbst verantwortlich; eine steuerliche Beratung findet nicht statt.
                    </Typography>
                </Box>
            </Paper>
        </Container>
    );
}
